import * as React from 'react';

import { requestDelete, requestPost } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'
import { Checkbox, } from '../../../Shared/index'

interface RemoveCoteacherModalProps {
  classroom: any;
  close: () => void;
  coteacher: any;
  onSuccess: (message: string) => void;
}

const RemoveCoteacherModal: React.FC<RemoveCoteacherModalProps> = ({ classroom, close, coteacher, onSuccess }) => {
  const { modalRef, } = useModalAccessibility(close)

  const [checkboxAcknowledged, setCheckboxAcknowledged] = React.useState<boolean>(false);

  const removeCoteacher = () => {
    const callback = (body: any) => {
      onSuccess('Co-teacher removed');
      close();
    };

    if (coteacher.invitation_id) {
      requestDelete(`/coteacher_classroom_invitations/${coteacher.id}`, {}, callback);
    } else {
      requestPost(
        `/classrooms_teachers/${coteacher.id}/remove_coteacher`,
        { classroom_id: classroom.id },
        callback
      );
    }
  };

  const submitButtonClass = () => {
    let buttonClass = 'quill-button contained red medium focus-on-light';
    if (!checkboxAcknowledged) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  };

  const toggleCheckbox = () => {
    setCheckboxAcknowledged(!checkboxAcknowledged)
  };

  const renderCheckboxes = () => (
    <div className="checkboxes">
      <div className="checkbox-row">
        <Checkbox
          label="I understand that the co-teacher will no longer have access to the students’ work or data."
          onClick={toggleCheckbox}
          selected={checkboxAcknowledged}
        />
      </div>
    </div>
  );

  const coteacherName =
    coteacher.invitation_id === true ? "This co-teacher's" : `${coteacher.name}'s`;

  return (
    <div className="modal-container remove-coteacher-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="removeCoteacherModalTitle"
        aria-modal="true"
        className="remove-coteacher-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="removeCoteacherModalTitle">
            Remove co-teacher from your class?
          </h3>
        </div>
        <p>
          {coteacherName} ({coteacher.email}) Quill account will remain active. You can re-invite the co-teacher
          later.
        </p>
        {renderCheckboxes()}
        <div className="form-buttons">
          <button className="quill-button outlined grey medium focus-on-light" onClick={close}>
            Cancel
          </button>
          <button className={submitButtonClass()} onClick={removeCoteacher}>
            Remove from class
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveCoteacherModal;
